import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="cs_privacy_page">
      <div className="container">
        <div className="cs_privacy_container">
          <h1>Privacy Policy</h1>
          <p className="cs_last_updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Information We Collect</h2>
            <h3>Personal Information</h3>
            <ul>
              <li>Name, email address, phone number</li>
              <li>Shipping and billing addresses</li>
              <li>Payment information (processed securely through Razorpay)</li>
              <li>Order history and preferences</li>
            </ul>
            
            <h3>Automatically Collected Information</h3>
            <ul>
              <li>IP address, browser type, device information</li>
              <li>Website usage data and analytics</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <ul>
              <li>Process and fulfill your orders</li>
              <li>Send order confirmations and shipping updates</li>
              <li>Provide customer support</li>
              <li>Improve our website and services</li>
              <li>Send promotional emails (with your consent)</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Payment Processing</h2>
            <p>We use Razorpay for secure payment processing. Your payment information is encrypted and processed directly by Razorpay. We do not store your complete credit card or debit card information on our servers.</p>
          </section>

          <section>
            <h2>4. Information Sharing</h2>
            <p>We do not sell, trade, or rent your personal information. We may share information with:</p>
            <ul>
              <li>Payment processors (Razorpay) for transaction processing</li>
              <li>Shipping partners for order delivery</li>
              <li>Legal authorities when required by law</li>
              <li>Service providers who assist in website operations</li>
            </ul>
          </section>

          <section>
            <h2>5. Data Security</h2>
            <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is entirely secure.</p>
          </section>

          <section>
            <h2>6. Your Rights</h2>
            <ul>
              <li>Access and update your personal information</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Request data portability</li>
            </ul>
          </section>

          <section>
            <h2>7. Cookies</h2>
            <p>We use cookies to enhance your browsing experience, analyze website traffic, and personalize content. You can control cookie settings through your browser preferences.</p>
          </section>


          <section>
            <h2>8. Changes to Privacy Policy</h2>
            <p>We may update this privacy policy periodically. Changes will be posted on this page with an updated revision date.</p>
          </section>

          <section>
            <h2>9. Contact Us</h2>
            <p>For privacy-related questions or concerns, contact us at:</p>
            <p>Email: privacy@ayumedix.com<br/>
            WhatsApp: <a href="https://wa.me/919313989270" target="_blank" rel="noopener noreferrer">+91 93139 89270</a></p>
          </section>
        </div>
      </div>

      <style jsx>{`
        .cs_privacy_page {
          min-height: 100vh;
          background: #f8f8f8;
          padding: 120px 0 80px;
        }
        .cs_privacy_container {
          max-width: 800px;
          margin: 0 auto;
          background: #ffffff;
          padding: 50px;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(18, 18, 18, 0.08);
        }
        .cs_privacy_container h1 {
          color: #121212;
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 10px;
          text-align: center;
        }
        .cs_last_updated {
          text-align: center;
          color: #666;
          margin-bottom: 40px;
          font-style: italic;
        }
        .cs_privacy_container section {
          margin-bottom: 35px;
        }
        .cs_privacy_container h2 {
          color: #121212;
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 15px;
          border-bottom: 2px solid #0b5e4b;
          padding-bottom: 5px;
        }
        .cs_privacy_container h3 {
          color: #121212;
          font-size: 18px;
          font-weight: 600;
          margin: 20px 0 10px;
        }
        .cs_privacy_container p {
          color: #4f4747;
          line-height: 1.6;
          margin-bottom: 15px;
        }
        .cs_privacy_container ul {
          color: #4f4747;
          line-height: 1.6;
          margin-left: 20px;
        }
        .cs_privacy_container li {
          margin-bottom: 8px;
        }
        @media (max-width: 768px) {
          .cs_privacy_page {
            padding: 100px 0 50px;
          }
          .cs_privacy_container {
            margin: 0 20px;
            padding: 30px 25px;
          }
          .cs_privacy_container h1 {
            font-size: 28px;
          }
          .cs_privacy_container h2 {
            font-size: 20px;
          }
        }
      `}</style>
    </div>
  );
}